import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { CreateDataExportSchemaConfigRequest, DataExportSchemaConfig } from '../types';
import { DATA_EXPORT_SCHEMA_CONFIGS_KEY } from './useDataExportSchemaConfigs';

export default function useCreateDataExportSchemaConfig() {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending: isLoading } = useMutation({
    mutationFn: (request: CreateDataExportSchemaConfigRequest) =>
      api.post<DataExportSchemaConfig>('/data-export-configs', request),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: DATA_EXPORT_SCHEMA_CONFIGS_KEY,
      });
    },
  });

  const createConfig = async (request: CreateDataExportSchemaConfigRequest) => {
    const response = await mutateAsync(request);
    return response.data;
  };

  return { createConfig, isLoading };
}
